import { render } from "./DocDetail.vue?vue&type=template&id=ae119796&scoped=true"
import script from "./DocDetail.vue?vue&type=script&lang=js"
export * from "./DocDetail.vue?vue&type=script&lang=js"

import "./DocDetail.vue?vue&type=style&index=0&id=ae119796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae119796"]])

export default __exports__